import { render, staticRenderFns } from "./TalentCareerPrice.vue?vue&type=template&id=2646ac1a&"
import script from "./TalentCareerPrice.vue?vue&type=script&lang=js&"
export * from "./TalentCareerPrice.vue?vue&type=script&lang=js&"
import style0 from "./TalentCareerPrice.vue?vue&type=style&index=0&id=2646ac1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports